import listing from './Listing';
import teaser from './Teaser';

const blockVariations = {
  listing,
  teaser,
};

export default blockVariations;
